import React, { useCallback, useState } from 'react'
import { debounce } from 'lodash';

interface SearchComponentProps {
    queryKey: string;
    onSearch: (query: string) => void;
    /** Default 'Search...' supaya pemakai lama tidak berubah perilakunya. */
    placeholder?: string;
}

const SearchComponent: React.FC<SearchComponentProps> = ({ queryKey, onSearch, placeholder = 'Search...' }) => {
    const [localSearchQuery, setLocalSearchQuery] = useState(queryKey);

    // Fungsi untuk menangani perubahan input
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setLocalSearchQuery(query);  // Update local state secara realtime
        debouncedSearch(query);      // Panggil debounced search
    };

    // Membuat debounced function hanya sekali menggunakan useCallback
    const debouncedSearch = useCallback(
        debounce((query) => {
            onSearch(query);
        }, 500), // 500ms debounce delay
        [] // Hanya inisialisasi sekali ketika komponen pertama kali dirender
    );

    return (
        <div className="input-icon">
            <input
                type="text"
                className="form-control"
                placeholder={placeholder}
                value={localSearchQuery}
                onChange={handleInputChange}
            />
            <span className="input-icon-addon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-search"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="10" cy="10" r="7" />
                    <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
            </span>
        </div>
    )
}

export default SearchComponent